<template>
  <span v-if="iconType" :class="wrapperClass">
    <a-icon :type="iconType" :class="iconClasses" />
    <template v-if="showLabel">{{ label }}</template>
  </span>
  <span v-else class="ben-type">—</span>
</template>

<script>
/**
 * Shared visuals for décaissement: provider (shop), associate (team), employee (user),
 * company (apartment), debiteur (bank).
 * Labels use factures.beneficiary* to stay aligned with list filters and payment entry.
 */
export default {
  name: "BeneficiaryTypeDisplay",
  props: {
    type: { type: String, default: "" },
    variant: {
      type: String,
      default: "inline",
      validator: (v) => ["inline", "legend"].includes(v),
    },
    showLabel: { type: Boolean, default: true },
  },
  computed: {
    iconType() {
      const m = {
        provider: "shop",
        associate: "team",
        employee: "user",
        company: "apartment",
        debiteur: "bank",
      };
      return m[this.type] || null;
    },
    wrapperClass() {
      return this.variant === "legend" ? "legend-item" : "ben-type";
    },
    iconClasses() {
      const c = `legend-${this.type}`;
      return this.variant === "legend" ? ["legend-icon", c] : [c];
    },
    label() {
      if (this.type === "provider")
        return this.$t("factures.beneficiaryProvider");
      if (this.type === "associate")
        return this.$t("factures.beneficiaryAssociate");
      if (this.type === "employee")
        return this.$t("factures.beneficiaryEmployee");
      if (this.type === "company")
        return this.$t("factures.beneficiaryCompany");
      if (this.type === "debiteur")
        return this.$t("factures.beneficiaryDebiteur");
      return "";
    },
  },
};
</script>
